import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Upload from './pages/Upload';
import Dashboard from './pages/Dashboard';
import Comprador from './pages/Comprador';
import Financeiro from './pages/Financeiro';
import Cronograma from './pages/Cronograma';
import Logistica from './pages/Logistica';
import ConferenciaNF from './pages/ConferenciaNF';
import ControlePedidos from './pages/ControlePedidos';
import Historico from './pages/Historico';
import Fornecedor from './pages/Fornecedor';
import ConclusaoExecutiva from './pages/ConclusaoExecutiva';
import ProtectedRoute from './components/ProtectedRoute';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/upload"              element={<Upload />} />
        <Route path="/dashboard"           element={<Dashboard />} />
        <Route path="/comprador"           element={<Comprador />} />
        <Route path="/financeiro"          element={<Financeiro />} />
        <Route path="/cronograma"          element={<Cronograma />} />
        <Route path="/logistica"           element={<Logistica />} />
        <Route path="/conferencia-nf"      element={<ConferenciaNF />} />
        <Route path="/controle-pedidos"    element={<ControlePedidos />} />
        <Route path="/historico"           element={<Historico />} />
        <Route path="/fornecedor"          element={<Fornecedor />} />
        <Route path="/conclusao-executiva" element={<ConclusaoExecutiva />} />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
